import {
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Button,
  TimePicker,
  Select,
} from "antd";
import React from "react";
import "./style.css";
import {
  validateMessages,
  disabledDatePast,
  disabledStartTime,
  disabledStartTime_Interview,
} from "../../../Function";

const dateFormat = "DD/MM/YYYY";

const ModalAddInterview = ({
  form,
  isModalAddInterview,
  handleCancelAddInterview,
  handleChangeTimeStart,
  handleChangeTimeEnd,
  // timeInterview,
  onFinishAddInterview,
  handleChangeDate,
  selectedDate,
  typeModal,
  onFinishDelete,
  dateTimeSelect,
  isEditNote,
  onFinishEdit,
  listUser,
  handleViewCVInterview
}) => {
  return (
    <Modal
      title={
        typeModal == "add" ? "Tạo lịch phỏng vấn" : "Chi tiết lịch phỏng vấn"
      }
      open={isModalAddInterview}
      onCancel={() => {
        handleCancelAddInterview();
        form.resetFields();
      }}
      width={800}
      footer={false}
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={(values) => {
          if (typeModal == "add") {
            onFinishAddInterview(values);
          } else {
            onFinishEdit(values);
          }
        }}
        // onFinishFailed={onFinishFailed}
        validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row className="modal-add-candidate-row">
          <Col span={11}>
            <Form.Item
              label="Tiêu đề"
              name="title"
              rules={[
                {
                  required: true,
                },
                {
                  pattern:
                    /^[a-zA-ZÀ-ỹ0-9-_\/\[\]]+(?:\s[a-zA-ZÀ-ỹ0-9-_\/\[\]]+)*$/,
                  message: "Tiêu đề có khoảng trắng bị thừa / sai định dạng!",
                },
                {
                  max: 50,
                  min: 5,
                  message:
                    "Tiêu đề phải có ít nhất 5 ký tự và lớn nhất 50 ký tự.",
                },
              ]}
            >
              <Input placeholder="Tiêu đề đặt lịch"></Input>
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item
              label="Ngày phỏng vấn"
              name="start_date"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                suffixIcon={null}
                placeholder="DD/MM/YYYY"
                format={dateFormat}
                disabledDate={disabledDatePast}
                onChange={handleChangeDate}
                disabled={typeModal == "view" ? true : false}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Giờ bắt đầu"
              name="time_start"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <TimePicker
                disabledTime={() => disabledStartTime_Interview(selectedDate)}
                hideDisabledOptions={true}
                showNow={false}
                allowClear={true}
                autoFocus={true}
                onSelect={handleChangeTimeStart}
                inputReadOnly={true}
                minuteStep={5}
                disabled={typeModal == "view" ? true : false}
                // value={timeInterview}
                // defaultValue={moment(startTime, "HH:mm")}
                format={"HH:mm"}
              />
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Giờ kết thúc"
              name="time_end"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <TimePicker
                disabledTime={() => disabledStartTime_Interview(selectedDate)}
                hideDisabledOptions={true}
                showNow={false}
                allowClear={true}
                autoFocus={true}
                onSelect={handleChangeTimeEnd}
                inputReadOnly={true}
                minuteStep={5}
                disabled={typeModal == "view" ? true : false}
                // value={timeInterview}
                // defaultValue={moment(startTime, "HH:mm")}
                format={"HH:mm"}
              />
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item
              label="Người phỏng vấn"
              name="user_interview"
              className="modal-add-cadidate-form-item"
            >
              <Select
                showSearch
                mode="multiple"
                style={{ width: 230 }}
                maxTagCount="responsive"
                optionFilterProp="children"
                placeholder="Chọn username"
                // defaultValue= { a }
                // filterOption={(input, option) =>
                //     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                // }
              >
                {listUser.map((item, index) => (
                  <Select.Option key={index} value={item.id}>
                    {item.username}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label={
                <>
                  Ghi chú &nbsp; <i>{dateTimeSelect.note_date}</i>
                </>
              }
              name="note"
            >
              <Input.TextArea
                autoSize={{
                  minRows: 2,
                }}
                maxLength={255}
                disabled={isEditNote}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {typeModal !== "add" && (
            <>
              <Col span={8} style={{ textAlign: "right" }}>
                <Button
                  type="primary"
                  className='btnGreen'
                  onClick={() => handleViewCVInterview(dateTimeSelect)}
                >
                  Xem CV
                </Button>
              </Col>
              <Col span={2} offset={1} style={{ textAlign: "right" }}>
                <Button
                  type="primary"
                  danger
                  onClick={() => onFinishDelete(dateTimeSelect)}
                >
                  Xóa lịch
                </Button>
              </Col>
            </>
          )}
          <Col
            span={typeModal === "add" ? 10 : 2}
            style={{ textAlign: "right" }}
            offset={1}
          >
            <Button type="primary" htmlType="submit">
              Lưu
            </Button>
          </Col>
          <Col
            span={2}
            style={{ textAlign: "right" }}
            offset={typeModal === "add" ? 2 : 1}
          >
            <Button onClick={handleCancelAddInterview}>Thoát</Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalAddInterview;
